// Module
var code = "<span class=\"link-bar\" ng-if=\"widget.rightControlsController.isLarge()\"> <button class=\"btn btn-link\" ng-click=\"widget.rightControlsController.expandAll()\"> Expand All </button> <button class=\"btn btn-link\" ng-click=\"widget.rightControlsController.collapseAll()\"> Collapse All </button> </span> ";
// Exports
module.exports = code;